module.exports = __webpack_public_path__ + "img/double-arrow-right.50f143b0.svg";